import { workflowRepository } from "motw_core/Repositories/WorkflowRepository";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { ISearchNodesState } from "source/app/presentation/MainPanel/Workflows/SearchNodes/Helpers/ISearchNodesState";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { minSearchLength } from "../Helpers/minSearchLength";

export async function ExecuteSearchAsync() {
    const searchNodes = State.ReadClass<ISearchNodesState>(
        ESharedComponent.SearchNodes
    );
    const text = searchNodes.state.searchText;

    if (text.length < minSearchLength) {
        return [];
    }

    if (searchNodes) {
        try {
            const filteredNodes = await WithAnimatedProgressBarAsync(() => {
                searchNodes.setState({ showLoadingIndicator: true });

                return workflowRepository.GetNodesMatching(
                    ClientDataProvider,
                    text
                );
            });

            searchNodes.setState({ filteredNodes });
        } finally {
            searchNodes.setState({ showLoadingIndicator: false });
        }
    }
}
